import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.array.find";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Text, StyleSheet, View, TouchableOpacity } from 'react-native';
import Color from './Color';
import { warning } from './utils';
var styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    maxWidth: 300
  },
  quickReply: {
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    maxWidth: 160,
    paddingVertical: 7,
    paddingHorizontal: 12,
    height: 50,
    borderRadius: 13,
    margin: 3
  },
  quickReplyText: {
    overflow: 'visible'
  },
  sendLink: {
    borderWidth: 0
  },
  sendLinkText: {
    color: Color.defaultBlue,
    fontWeight: '600',
    fontSize: 17
  }
});

var sameReply = function sameReply(currentReply) {
  return function (reply) {
    return currentReply.value === reply.value;
  };
};

var diffReply = function diffReply(currentReply) {
  return function (reply) {
    return currentReply.value !== reply.value;
  };
};

var QuickReplies =
/*#__PURE__*/
function (_Component) {
  _inherits(QuickReplies, _Component);

  function QuickReplies() {
    var _this;

    _classCallCheck(this, QuickReplies);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(QuickReplies).apply(this, arguments));
    _this.state = {
      replies: []
    };

    _this.handlePress = function (reply) {
      return function () {
        var currentMessage = _this.props.currentMessage;
        var replies = _this.state.replies;

        if (currentMessage) {
          var type = currentMessage.quickReplies.type;

          switch (type) {
            case 'radio':
              {
                _this.handleSend([reply])();

                return;
              }

            case 'checkbox':
              {
                if (replies.find(sameReply(reply))) {
                  _this.setState({
                    replies: _this.state.replies.filter(diffReply(reply))
                  });
                } else {
                  _this.setState({
                    replies: [].concat(_toConsumableArray(_this.state.replies), [reply])
                  });
                }

                return;
              }

            default:
              {
                warning("onQuickReply unknown type: ".concat(type));
                return;
              }
          }
        }
      };
    };

    _this.handleSend = function (replies) {
      return function () {
        var currentMessage = _this.props.currentMessage;

        if (_this.props.onQuickReply) {
          _this.props.onQuickReply(replies.map(function (reply) {
            return _objectSpread({}, reply, {
              messageId: currentMessage._id
            });
          }));
        }
      };
    };

    _this.shouldComponentDisplay = function () {
      var _this$props = _this.props,
          currentMessage = _this$props.currentMessage,
          nextMessage = _this$props.nextMessage;
      var hasReplies = !!currentMessage && !!currentMessage.quickReplies;
      var hasNext = !!nextMessage && !!nextMessage._id;
      var keepIt = currentMessage.quickReplies.keepIt;

      if (hasReplies && !hasNext) {
        return true;
      }

      if (hasReplies && hasNext && keepIt) {
        return true;
      }

      return false;
    };

    _this.renderQuickReplySend = function () {
      var replies = _this.state.replies;
      var _this$props2 = _this.props,
          sendText = _this$props2.sendText,
          customSend = _this$props2.renderQuickReplySend;
      return React.createElement(TouchableOpacity, {
        style: [styles.quickReply, styles.sendLink],
        onPress: _this.handleSend(replies)
      }, customSend ? customSend() : React.createElement(Text, {
        style: styles.sendLinkText
      }, sendText));
    };

    return _this;
  }

  _createClass(QuickReplies, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          currentMessage = _this$props3.currentMessage,
          color = _this$props3.color,
          quickReplyStyle = _this$props3.quickReplyStyle;
      var replies = this.state.replies;

      if (!this.shouldComponentDisplay()) {
        return null;
      }

      var type = currentMessage.quickReplies.type;
      return React.createElement(View, {
        style: styles.container
      }, currentMessage.quickReplies.values.map(function (reply, index) {
        var selected = type === 'checkbox' && replies.find(sameReply(reply));
        return React.createElement(TouchableOpacity, {
          onPress: _this2.handlePress(reply),
          style: [styles.quickReply, quickReplyStyle, {
            borderColor: color
          }, selected && {
            backgroundColor: color
          }],
          key: "".concat(reply.value, "-").concat(index)
        }, React.createElement(Text, {
          numberOfLines: 2,
          ellipsizeMode: 'tail',
          style: [styles.quickReplyText, {
            color: selected ? Color.white : color
          }]
        }, reply.title));
      }), replies.length > 0 && this.renderQuickReplySend());
    }
  }]);

  return QuickReplies;
}(Component);

export { QuickReplies as default };
QuickReplies.defaultProps = {
  currentMessage: {
    quickReplies: []
  },
  onQuickReply: function onQuickReply() {},
  color: Color.peterRiver,
  sendText: 'Send',
  keepReplies: false,
  renderQuickReplySend: undefined,
  quickReplyStyle: undefined
};
QuickReplies.propTypes = {
  currentMessage: PropTypes.object.isRequired,
  onQuickReply: PropTypes.func,
  color: PropTypes.string
};